import React, { useEffect } from 'react';
import './ThreeDAnimation.css';

const ThreeDAnimation = () => {


  

  useEffect(() => {
    // Intersection Observer for visibility animations
    const elements = document.querySelectorAll('.tda-card, .tda-feature, .tda-diff-card, .tda-step');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("tda-visible");
        }
      });
    }, { threshold: 0.2 });

    elements.forEach(el => {
      el.classList.add("tda-hidden");
      observer.observe(el);
    });

    // Mobile menu event listeners
    const hamburger = document.getElementById("tda-hamburger");
    const mobileMenu = document.getElementById("tda-mobileMenu");
    const mobileClose = document.getElementById("tda-mobileClose");
    const overlay = document.getElementById("tda-overlay");
    const toggles = document.querySelectorAll(".tda-mobile-toggle");

    if (hamburger && mobileMenu && mobileClose && overlay) {
      hamburger.addEventListener("click", () => {
        mobileMenu.classList.add("tda-open");
        overlay.classList.add("tda-open");
      });

      mobileClose.addEventListener("click", () => {
        mobileMenu.classList.remove("tda-open");
        overlay.classList.remove("tda-open");
      });

      overlay.addEventListener("click", () => {
        mobileMenu.classList.remove("tda-open");
        overlay.classList.remove("tda-open");
      });

      toggles.forEach(toggle => {
        toggle.addEventListener("click", () => {
          toggle.nextElementSibling.classList.toggle("tda-open");
        });
      });
    }

    // Active link handling
    const navLinks = document.querySelectorAll(".tda-nav-links a");
    const mobileLinks = document.querySelectorAll(".tda-mobile-nav a");
    const dropdownButton = document.querySelector('.tda-dropbtn');
    const mobileToggle = document.querySelector('.tda-mobile-toggle');

    const currentPath = window.location.pathname.split('/').pop() || '3danimations.html';

    function setActiveLink(link) {
      mobileLinks.forEach(l => l.classList.remove('tda-active'));
      if (mobileToggle) mobileToggle.classList.remove('tda-active');
      if (dropdownButton) dropdownButton.classList.remove('tda-active');

      if (link) {
        link.classList.add('tda-active');
        if (link.closest('.tda-dropdown-content') || link.closest('.tda-mobile-sub')) {
          if (dropdownButton) dropdownButton.classList.add('tda-active');
          if (mobileToggle) mobileToggle.classList.add('tda-active');
        }
      }
    }

    navLinks.forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        setActiveLink(link);
      }
    });
    mobileLinks.forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        setActiveLink(link);
      }
    });

    navLinks.forEach(link => {
      link.addEventListener("click", () => {
        setActiveLink(link);
      });
    });

    mobileLinks.forEach(link => {
      link.addEventListener("click", () => {
        setActiveLink(link);
        if (mobileMenu && overlay) {
          mobileMenu.classList.remove("tda-open");
          overlay.classList.remove("tda-open");
        }
      });
    });

    if (dropdownButton) {
      dropdownButton.addEventListener('click', () => {
        if (dropdownButton.classList.contains('tda-active')) {
          dropdownButton.classList.remove('tda-active');
        } else {
          setActiveLink(null);
          dropdownButton.classList.add('tda-active');
        }
      });
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        if (mobileToggle.classList.contains('tda-active')) {
          mobileToggle.classList.remove('tda-active');
        } else {
          setActiveLink(null);
          mobileToggle.classList.add('tda-active');
        }
      });
    }

    // Cleanup event listeners on unmount
    return () => {
      elements.forEach(el => observer.unobserve(el));
      // Remove other event listeners if necessary
    };
  }, []);

  return (
    <>
      <section className="tda-hero">
        <div className="tda-hero-content">
          <h1>3D-Animations</h1>
          <h1>Elevating Ideas with <span>3D Animation</span></h1>
          <p>Transforming imagination into immersive, interactive experiences.</p>
          <a href="mailto:info@oakyaitservices.com" className="td-btn">Get Your Free Consultation</a>
        </div>
      </section>
      <section className="tda-whatwedo" id="whatwedo">
        <h2><i className="fas fa-cube"></i> What We Do</h2>
        <p>We bring your vision to life with dynamic 3D models, characters, environments, and stories—making your product or brand unforgettable.</p>
        <div className="what-tda-cards">
          <div className="tda-card">
            <i className="fas fa-cubes"></i>
            <h3>Concepts to Reality</h3>
            <p>Turning ideas into compelling 3D visuals that inspire and engage.</p>
          </div>
          <div className="tda-card">
            <i className="fas fa-vr-cardboard"></i>
            <h3>Immersive Experiences</h3>
            <p>Crafting lifelike animations that captivate audiences across industries.</p>
          </div>
          <div className="tda-card">
            <i className="fas fa-film"></i>
            <h3>Storytelling</h3>
            <p>Creating narratives that resonate with clarity and emotion.</p>
          </div>
        </div>
      </section>
      <section className="tda-whychoose">
        <h2><i className="fas fa-star"></i> Why Choose 3D Animation</h2>
        <div className="tda-features">
          <div className="tda-feature"><i className="fas fa-magnet"></i><h4>Unmatched Engagement</h4><p>3D animations captivate with depth, realism, and motion, holding viewer attention more effectively than static visuals or text.</p></div>
          <div className="tda-feature"><i className="fas fa-brain"></i><h4>Clear Communication</h4><p>Complex ideas, internal mechanics, or abstract concepts become instantly comprehensible through visual storytelling.</p></div>
          <div className="tda-feature"><i className="fas fa-project-diagram"></i><h4>Efficient Prototyping</h4><p>Before manufacturing or filming, visualize ideas accurately using 3D animation, saving time and resources.</p></div>
          <div className="tda-feature"><i className="fas fa-industry"></i><h4>Versatile Applications</h4><p>From marketing and training to architectural walk-throughs and product showcases, 3D works across industries and formats.</p></div>
        </div>
      </section>
      <section className="tda-workflow" id="workflow">
        <div className="tda-content">
          <h2>Our Creative Workflow</h2>
          <p>Step-by-step journey from idea to final masterpiece.</p>
          <div className="tda-timeline">
            <div className="tda-step">
              <i className="fas fa-pencil-alt"></i>
              <h4>Creative Brief</h4>
              <p>We begin with a collaborative guide that captures your goals, tone, and vision.</p>
            </div>
            <div className="tda-step">
              <i className="fas fa-image"></i>
              <h4>Storyboarding</h4>
              <p>Concepts are sketched and visual flows planned for clarity and alignment.</p>
            </div>
            <div className="tda-step">
              <i className="fas fa-cube"></i>
              <h4>Modeling</h4>
              <p>Characters, products, or environments are crafted in detail from scratch.</p>
            </div>
            <div className="tda-step">
              <i className="fas fa-sun"></i>
              <h4>Texturing & Lighting</h4>
              <p>Color, surface quality, and lighting are applied to add realism and mood.</p>
            </div>
            <div className="tda-step">
              <i className="fas fa-user-friends"></i>
              <h4>Rigging</h4>
              <p>We build digital "skeletons" that allow lifelike movement and flexibility.</p>
            </div>
            <div className="tda-step">
              <i className="fas fa-film"></i>
              <h4>Animation</h4>
              <p>Models are animated, expressions, motions, and dynamics are brought to life.</p>
            </div>
            <div className="tda-step">
              <i className="fas fa-magic"></i>
              <h4>Compositing & Effects</h4>
              <p>Visual elements, effects, and sound are combined for polish and impact.</p>
            </div>
            <div className="tda-step">
              <i className="fas fa-check-circle"></i>
              <h4>Render & Review</h4>
              <p>Final scenes are rendered, refined, and prepared for delivery in your format.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="tda-team" id="team">
        <h2><i className="fas fa-users"></i> Our Talent Pool – Your Creative Team</h2>
        <div className="tda-cards">
          <div className="tda-card"><i className="fas fa-user-tie"></i><h4>Creative Lead / Director</h4><p>Oversees the vision, ensures consistency, and manages communication.</p></div>
          <div className="tda-card"><i className="fas fa-paint-brush"></i><h4>Concept & Model Artists</h4><p>Design initial visuals and build detailed 3D models.</p></div>
          <div className="tda-card"><i className="fas fa-running"></i><h4>Riggers & Animators</h4><p>Equip models with movement and bring emotions and actions into motion.</p></div>
          <div className="tda-card"><i className="fas fa-lightbulb"></i><h4>Lighting & Render Artists</h4><p>Light scenes and finalize visuals with texture, mood, and aesthetics.</p></div>
          <div className="tda-card"><i className="fas fa-music"></i><h4>Compositors & Sound Designers</h4><p>Blend visual elements and perfect audio to elevate immersion.</p></div>
          <div className="tda-card"><i className="fas fa-check"></i><h4>Quality Assurance</h4><p>Ensures every frame is seamless, synced, and error-free before delivery.</p></div>
        </div>
      </section>
      <section className="tda-different">
        <h2>What Makes Us Different</h2>
        <div className="tda-different-cards">
          <div className="tda-diff-card">
            <i className="fas fa-paint-brush"></i>
            <h4>Tailored for You</h4>
            <p>Every animation is crafted with your brand personality and goals in mind.</p>
          </div>
          <div className="tda-diff-card">
            <i className="fas fa-cogs"></i>
            <h4>End-to-End Excellence</h4>
            <p>From inception to final output, we manage all stages professionally.</p>
          </div>
          <div className="tda-diff-card">
            <i className="fas fa-handshake"></i>
            <h4>Collaborative Revisions</h4>
            <p>Your feedback shapes the project, iterative checkpoints keep us aligned.</p>
          </div>
          <div className="tda-diff-card">
            <i className="fas fa-bolt"></i>
            <h4>Efficient, Yet High Quality</h4>
            <p>We strike a balance between speed and attention to detail.</p>
          </div>
          <div className="tda-diff-card">
            <i className="fas fa-balance-scale"></i>
            <h4>Transparent Pricing</h4>
            <p>Cost is aligned with project complexity, no hidden fees or surprises.</p>
          </div>
        </div>
      </section>
      <section className="tda-industries" id="industries">
        <h2><i className="fas fa-industry"></i> Applications & Industries</h2>
        <div className="tda-features">
          <div className="tda-feature"><i className="fas fa-box-open"></i><h4>Product Showcases</h4><p>Highlight features and functionality in a visually compelling way.</p></div>
          <div className="tda-feature"><i className="fas fa-chalkboard-teacher"></i><h4>Explainer & Instructional Videos</h4><p>Teach processes effectively, without ambiguity.</p></div>
          <div className="tda-feature"><i className="fas fa-building"></i><h4>Architectural Visualization</h4><p>Present interiors and exteriors before construction.</p></div>
          <div className="tda-feature"><i className="fas fa-bullhorn"></i><h4>Marketing & Brand Storytelling</h4><p>Create memorable narratives that resonate and persuade.</p></div>
          <div className="tda-feature"><i className="fas fa-drafting-compass"></i><h4>Prototyping & Internal Communication</h4><p>Align teams and clients early in the design phase.</p></div>
        </div>
        
      </section>
    </>
  );
};

export default ThreeDAnimation;